import { useCallback } from "react";
import useHistory from "routing/useHistory";
import useInvestigationPanel from "security-app/components/Investigations/hooks/useInvestigationPanel";
const useGoToEvidencePage = (investigationId, destination) => {
  const history = useHistory();
  const { openInvestigation, setSelectedInvestigationId } = useInvestigationPanel();
  return useCallback(() => {
    setSelectedInvestigationId(investigationId);
    openInvestigation(investigationId);
    history.push(destination);
  }, [destination, history, investigationId, openInvestigation, setSelectedInvestigationId]);
};
export default useGoToEvidencePage;
